module.exports = __webpack_public_path__ + "static/media/banner-desktop.54674c68.png";